
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'brand.asia365': `Kuoni Specialist asia365`,
'brand.dorado': `Kuoni Specialist Dorado Latin Tours`,
'brand.kontiki': `Kuoni Specialist Kontiki Reisen`,
'brand.kuoni': `Kuoni Reisen`,
'brand.manta': `Kuoni Specialist Manta Reisen`,
'brand.privatesafaris': `Kuoni Specialist Private Safaris`,
'h5525336a2a7d8957': html`Dates de départ et prix`,
's0e5d59a511871fea': `Demande de voyage`,
's0f7dc76026813d39': `par personne`,
's296166c7f23d13fd': `Taille du groupe`,
's2b9f7cfbe1b6b1e6': `Langues`,
's3391fc7962b4683a': `dès`,
's57ca97c2f0a4c6b5': `Durée`,
's62033155aecbb40d': `Organisé par`,
's671825922220383a': `Type de circuit`,
's85290b4f5c072c6d': `Départ/Arrivée`,
's9e2f88fd1529caef': `Point de départ`,
'sbbe5bcf68495ce1e': `Demandes d'offres`,
'sd3b625485ff04ca8': `À la prochaine date de départ possible`,
'sd98f9b1f87289338': `Prix par personne en`,
'sf6b408446d496c60': `Continuer sans date`,
'sfd47ac0846790fd8': `Meilleure période de voyage`,
'he43b6d98cfbb1dd0': html`calendarInfoText <a href="tel:${0}">${1}</a>`,
    };
  